export interface PrintInfo {
    available?: boolean;
    message?: string;
}
